<template>
  <div class="min-w-0">
    <div v-if="variationOrder.totalBudget">
      <span v-if="linkedBudget !== undefined">Variation budget:</span> {{ australianCurrency(variationOrder.totalBudget) }}
    </div>

    <div v-else>
      Variation budget AIP
    </div>

    <div
      v-if="linkedBudget !== undefined"
      class="text-xs text-gray-500"
    >
      Contract item budget: {{ australianCurrency(linkedBudget) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { australianCurrency } from '@/helpers';
import VariationOrder, { VariationOrderType } from '@/models/VariationOrder';
import { computed } from 'vue';

const props = defineProps<{
  variationOrder: VariationOrder;
}>();

const linkedBudget = computed(() => {
  if(props.variationOrder.type !== VariationOrderType.provisional_sum) {
    return undefined;
  }

  if(props.variationOrder.head_contract_trade_item_id) {
    return props.variationOrder.head_contract_trade_item?.budget;
  }

  if(props.variationOrder.package_trade_item_id) {
    return props.variationOrder.package_trade_item?.value;
  }

  return undefined;
});
</script>
